var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"link",attrs:{"to":{name: _vm.link, novelId: _vm.novelId}}},[_c('div',[_vm._t("default")],2),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }